import { t } from '@lingui/core/macro';
import { noddiToast } from 'noddi-ui-web';

export const showNewUserPromotionIneligibleToast = (userName: string) => {
  noddiToast.error(t`Not eligible`, {
    description: t`The account registered under ${userName} already has discounts or an active account. This offer is only for new users without previous promotions.`,
    duration: 5000
  });
};
